// src/components/SessionExpiredPopup.jsx
import React, { useEffect } from 'react';
import './SessionExpiredPopup.css';

const SessionExpiredPopup = ({ isVisible, onClose, onRelogin }) => {
  useEffect(() => {
    document.body.style.overflow = isVisible ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isVisible]);

  if (!isVisible) return null;

  const handleRelogin = () => {
    // caller is responsible for clearing storage / logout
    if (typeof onRelogin === 'function') onRelogin();
    if (typeof onClose === 'function') onClose();
  };

  return (
    <>
      <div className="session-expired-overlay" />
      <div className="session-expired-popup">
        <h2>Session Expired</h2>
        <p>Your session has expired. Please log in again to continue.</p>
        <button onClick={handleRelogin} className="relogin-button">
          Log In
        </button>
      </div>
    </>
  );
};

export default SessionExpiredPopup;
